@if (!dismissed) {
  <div class="administration-credentials-banner" data-cy="administration-credentials-banner">
    <mat-icon>warning</mat-icon>
    <span>
      Certains comptes artefact ne sont pas configurés ou sont invalides. L'envoi des absences vers
      l'administration ne pourra pas se faire.
      <a routerLink="admin/settings/administrationCredentials" data-cy="administration-credentials-banner-link">Configurer les comptes artefact</a>
    </span>
    <button mat-icon-button
            class="close-button"
            aria-label="Fermer"
            (click)="dismiss()"
            data-cy="administration-credentials-banner-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
